<template>
  <donut-chart-card
    title="원료·제조물 사업장 안전예산 현황"
    :value="data"
    :donut-value="donutValue"
    :donut-unit="donutUnit"
    :total="total"
    unit="원"
    :isMoveWrite="isMoveWrite"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
/* eslint-disable brace-style */
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart32',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'field_cat1' | 'company' | 'project',
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 32,
      boardIds: [409],
      summaryKeys: {
        'detail' : ['안전보건예산_항목명', 'sum'],
        'field' : ['안전보건예산_사업장명', 'sum'],
        'address': ['안전보건예산_사업장주소', 'sum'],
        'field_cat1' : ['유해위험요인점검_사업장구분', 'sum'],
        'company' : ['안전보건예산_항목명', 'sum'],
        'project' : ['안전보건예산_항목명', 'sum'],
      },
      data: [{label: '데이터 없음', value: 0}],
      total: '0',
      donutValue: -1,
      donutUnit: '원',
      cache: {},
    }
  },
  async mounted () {
    await this.loadDetailData();
    await this.loadGraph()
  },
  methods: {
    async loadDetailData(currentYear, depth) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      if (!depth) {
        depth = 1;
      }

      const cacheKey = `detail_${currentYear}_${depth}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return this.cache[cacheKey];
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          projectId: this.projectId,
          fieldCode: 'workplace-material',
          depth
        };

        const data = await this.$store.dispatch("summary/LOAD_DONUT_15_DETAIL", params);
        this.cache[cacheKey] = data;
        return data;
      }
    },
    async loadGraph () {
      const data = await this.loadDetailData()

      let graph2Data = [];
      if (!this.projectId) {
        graph2Data = data.project;
      } else {
        switch (this.getLevel) {
        case 1:
        case 2:
          graph2Data = data.company;
          break;
        case 3:
        case 4:
        default:
          graph2Data = data.field;
          break;
        }
      }

      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;

      const currentData = graph2Data[currentYear][currentMonth];

      const list = [];
      let no = 1;

      for (const row of currentData) {
        list.push({
          label: row.label,
          value: row.budget,
        });
        no += 1;

        if (no > 5) break;
      }

      const totalBudget = data.monthlyBudget[currentYear][currentMonth];
      if (totalBudget > 999999999) {
        this.donutUnit = '천원';
        this.donutValue = Math.floor(totalBudget / 1000);
      } else {
        this.donutUnit = '원';
        this.donutValue = totalBudget;
      }
      this.total = new Intl.NumberFormat().format(totalBudget);
      this.data = list;
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
